import { render, staticRenderFns } from "./notFount.vue?vue&type=template&id=7119f7c8&scoped=true&"
import script from "./notFount.vue?vue&type=script&lang=js&"
export * from "./notFount.vue?vue&type=script&lang=js&"
import style0 from "./notFount.vue?vue&type=style&index=0&id=7119f7c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7119f7c8",
  null
  
)

export default component.exports